<template>
  <div style="white-space: nowrap;">
    <label :for="inputId" style="margin-bottom: 0; user-select: none;display: inline-block;vertical-align: middle;"  :style="{'cursor' : disabled ? 'initial':'pointer'}">
      <span v-if="isOn" class="text-ok-label" :class="disabled ? 'text-disabled':''">{{textOn}}</span>
      <span v-else :class="disabled ? 'text-disabled':''">{{textOff}}</span>
    </label>
    
    <div class="custom-control custom-switch" style="margin-left: 0.25rem; margin-right: 0.25rem; display:inline-block;vertical-align:middle;" >
      <!--/* :checkedにも値を設定しないとCSSとずれる */-->
      <input :id="inputId" type="checkbox" autocomplete="off" :value="isOn" :checked="isOn" class="custom-control-input" @input="onChange" :disabled="disabled" @keydown.enter="onChange" />
      <label class="custom-control-label" :class="disabled ? 'disabled':''" :for="inputId">
        <span class="custom-control-label-before"></span>
        <span class="custom-control-label-after"></span>
      </label>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import RootVue from "@/RootVue.vue";

let createdCount = 0

@Options({
  props:{
    textOn:{
      type:String,
    },
    textOff:{
      type:String,
    },
    isOn:{
      type:Boolean,
      default: false,
    },
    disabled:{
      type:Boolean,
      default: false,
    },
  }
})

export default class extends Vue {
  // @ts-expect-error
  $root: RootVue;
  readonly textOn!:string;
  readonly textOff!:string;
  readonly isOn!:boolean;
  readonly disabled!:boolean;
  
  inputId = ""

  onChange(){
    //isOnを更新する。子側では（propsで渡された側では）直接更新できないので、親に更新を通知する
    this.$emit('update:isOn', !this.isOn)
  }
  created(){
    ++createdCount
    this.inputId = "switch-src-open" + createdCount
  }
}
</script>
<style lang="scss" scoped>

.custom-control {
    display: block;
    min-height: 1.5rem;
    padding-left: 1.5rem;
    print-color-adjust: exact;
}
.custom-control-input {
    display: none;
}

.custom-control-input:checked~*>.custom-control-label-before {
    color: #fff;
    border-color: #333;
    background-color: #333;
}
.custom-control-input:checked~*>.custom-control-label-before.disabled {
    color: #fff;
    border-color: #999;
    background-color: #999;
}
.custom-switch .custom-control-input:checked~*>.custom-control-label-after {
    background-color: #fff;
    transform: translateX(.75rem);
}

.custom-control-input:focus~*>.custom-control-label-before {
    box-shadow: 0 0 0 0.2rem rgba(22, 22, 22, .25);
}


.custom-control-label {
    cursor:pointer;
    position: relative;
    margin-bottom: 0;
    vertical-align: top;
    display:inline-block;
}
.custom-control-label.disabled {
    cursor:initial;
}

.custom-control-label-after {
    position: absolute;
    top: .25rem;
    left: -1.5rem;
    display: block;
    width: 1rem;
    height: 1rem;
    content: "";
    background: no-repeat 50%/50% 50%;
}

.custom-control-label-before {
    transition: background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
.custom-control-label-before {
    position: absolute;
    top: .25rem;
    left: -1.5rem;
    display: block;
    width: 1rem;
    height: 1rem;
    pointer-events: none;
    content: "";
    background-color: #fff;
    border: #adb5bd solid 1px;
}
.custom-switch .custom-control-label-after {
    top: calc(.25rem + 2px);
    left: calc(-2.25rem + 2px);
    width: calc(1rem - 4px);
    height: calc(1rem - 4px);
    background-color: #adb5bd;
    border-radius: .5rem;
    transition: transform .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}

.custom-switch {
    padding-left: 2.25rem;
}
.custom-switch .custom-control-label-before {
    left: -2.25rem;
    width: 1.75rem;
    pointer-events: all;
    border-radius: .5rem;
}

@media (prefers-reduced-motion: reduce){
    .custom-switch .custom-control-label-after {
        transition: none;
    }
}
@media (prefers-reduced-motion: reduce){
    .form-control {
        transition: none;
    }
    .custom-control-label-before{
        transition: none;
    }
}

@media (min-width: 768px){
    .custom-control-label-before{
        transition: none;
    }
    
}
</style>
